import { APPLICATION_MODE } from 'src/data/system';
import { useApplicationMode } from './useApplicationMode';

export const useIsApplicationModeInfinity = () => {
  const applicationMode = useApplicationMode();
  return applicationMode === APPLICATION_MODE.infinityExtension;
};
